import React from "react";
import { useDispatch, useSelector } from "react-redux";
import UploadProgressList from "../../common/UploadProgressList";
import { removeVideoNotification } from "../../../slice/notificationSlice";

export function formatUploadBytes(bytes) {
  const value = Number(bytes || 0);
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
  if (value < 1024 * 1024 * 1024) return `${(value / (1024 * 1024)).toFixed(1)} MB`;
  return `${(value / (1024 * 1024 * 1024)).toFixed(1)} GB`;
}

function uploadDetail(upload) {
  if (upload.status === "preparing") return "Preparing a secure multipart upload…";
  if (upload.status === "processing") return "All bytes transferred. Finalising the recording…";
  if (upload.status === "completed") return `${formatUploadBytes(upload.totalBytes)} uploaded successfully`;
  if (upload.status !== "uploading") return "";

  const transferred = `${formatUploadBytes(upload.uploadedBytes)} of ${formatUploadBytes(upload.totalBytes)}`;
  if (upload.estimated_time_in_min > 0) return `${transferred} • about ${upload.estimated_time_in_min} min remaining`;
  if (upload.estimated_time_in_sec > 0) return `${transferred} • about ${upload.estimated_time_in_sec} sec remaining`;
  return transferred;
}

export function toVideoUploadItems(uploads) {
  if (!Array.isArray(uploads)) return [];
  return uploads
    .filter((upload) => upload && (upload.id || upload.title))
    .map((upload) => ({
      id: upload.id || upload.title,
      name: upload.fileName || upload.title || "Recording",
      progress: Number(upload.uploadedpercent || 0),
      status: upload.status || "uploading",
      error: upload.error || null,
      detail: uploadDetail(upload),
    }));
}

const VideoUploadProgress = () => {
  const dispatch = useDispatch();
  const uploads = useSelector((state) => state.notificationData.video_notification);
  const items = toVideoUploadItems(uploads);

  return (
    <UploadProgressList
      items={items}
      className="mentor-upload-progress--video"
      onDismiss={(id) => dispatch(removeVideoNotification(id))}
    />
  );
};

export default VideoUploadProgress;
